import window from 'global';
import lzString from 'lz-string';

export const getCompressedContentKey = (store, entryId) => {
  return `${store.viewer.artifactId}:${entryId}`;
};

export const setChangelogCompressedContentInLocalStorage = (store, entry) => {
  const entryId = entry.target.id;
  const localStorageKey = getCompressedContentKey(store, entryId);
  const compressedContent = entry.target.getAttribute('data-changelog-content');
  try {
    window.localStorage.setItem(
      localStorageKey,
      JSON.stringify(compressedContent),
    );
  } catch (e) {
    console.error(e);
    window && window.Sentry.captureException(e);
  }
};

export const getCompressedMdContent = (content) =>
  lzString.compressToUTF16(content);
